export default __webpack_public_path__ + "media/people.ac215232.svg";